/**
 * 全局配置
 */

const Setting = {
    baseUrl: 'https://tv.lqb666.cn/api2',
    modalDuration: 1000, //弹窗时间
    title: '文创上新后台管理系统',//网站标题
    timeout: 30000,//请求超时
}

export default Setting;